import versioningSaga, { getVersion, upgradeVersion } from '~/sagas/versioning/versioning.saga';

export default versioningSaga;

export { getVersion, upgradeVersion };
